import React from 'react';

import { useGqlContext } from '@search/gql-client/src';

import { SubscribeToOfferPriceChangeMutation } from './SubscribeToOfferPriceChangeMutation/SubscribeToOfferPriceChangeMutation';
import {
    SubscribeToOfferPriceChangeMutation$data as SubscribeToOfferPriceChangeMutationResponse,
    SubscribeToOfferPriceChangeMutation$variables as SubscribeToOfferPriceChangeMutationVariables
} from './SubscribeToOfferPriceChangeMutation/__generated__/SubscribeToOfferPriceChangeMutation.graphql';
import { UnsubscribeFromOfferPriceChangeMutation } from './UnsubscribeFromOfferPriceChangeMutation/UnsubscribeFromOfferPriceChangeMutation';
import {
    UnsubscribeFromOfferPriceChangeMutation$data as UnsubscribeFromOfferPriceChangeMutationResponse,
    UnsubscribeFromOfferPriceChangeMutation$variables as UnsubscribeFromOfferPriceChangeMutationVariables
} from './UnsubscribeFromOfferPriceChangeMutation/__generated__/UnsubscribeFromOfferPriceChangeMutation.graphql';
import { SetSubscriptionFrequencyMutation } from './SetSubscriptionFrequencyMutation/SetSubscriptionFrequencyMutation';
import {
    SetSubscriptionFrequencyMutation$variables as SetSubscriptionFrequencyMutationVariables,
    SetSubscriptionFrequencyMutation$data as SetSubscriptionFrequencyMutationResponse
} from './SetSubscriptionFrequencyMutation/__generated__/SetSubscriptionFrequencyMutation.graphql';

export function useSubscribeToPriceChangeFetcher() {
    const gql = useGqlContext();

    return React.useCallback(
        (vars: SubscribeToOfferPriceChangeMutationVariables, opts?: { signal?: AbortSignal }) => gql.client<
            SubscribeToOfferPriceChangeMutationVariables,
            SubscribeToOfferPriceChangeMutationResponse
        >(SubscribeToOfferPriceChangeMutation, vars, opts),
        [ gql ]
    );
}

export function useUnsubscribeFromOfferPriceChangeFetcher() {
    const gql = useGqlContext();

    return React.useCallback(
        (vars: UnsubscribeFromOfferPriceChangeMutationVariables, opts?: { signal?: AbortSignal }) => gql.client<
            UnsubscribeFromOfferPriceChangeMutationVariables,
            UnsubscribeFromOfferPriceChangeMutationResponse
        >(UnsubscribeFromOfferPriceChangeMutation, vars, opts),
        [ gql ]
    );
}

export function useSetSubscriptionFrequencyFetcher() {
    const gql = useGqlContext();

    return React.useCallback(
        (vars: SetSubscriptionFrequencyMutationVariables, opts?: { signal?: AbortSignal }) => gql.client<
            SetSubscriptionFrequencyMutationVariables,
            SetSubscriptionFrequencyMutationResponse>(SetSubscriptionFrequencyMutation, vars, opts),
        [ gql ]
    );
}
